import { onCLS, onLCP, onINP, onTTFB, type Metric } from 'web-vitals';
import { captureError } from '@/services/sentry';

function reportMetric(metric: Metric): void {
  if (import.meta.env.DEV) {
    console.debug(`[Web Vitals] ${metric.name}:`, metric.value.toFixed(2));
  }
}

export function initWebVitals(): void {
  try {
    onCLS(reportMetric);
    onLCP(reportMetric);
    onINP(reportMetric);
    onTTFB(reportMetric);
  } catch (err) {
    captureError(err, { context: 'web-vitals-init' });
  }
}
